export default function CCHCreateEvent() {
  return (
    <div style={{ padding: 20 }}>
      <h2>Formularul de creare vine la Pasul 6...</h2>
    </div>
  );
}
